import { Component, Input, TemplateRef } from '@angular/core';
import { DynamicFieldModel } from '../../../index';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'shared-ui-dynamic-form-datepicker',
  imports: [NgTemplateOutlet],
  template: `
    @if (template) {
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ fieldModel }"></ng-container>
    }
  `,
  styles: ``,
})
export class DynamicFormDatepickerComponent {
  @Input() template?: TemplateRef<unknown>;
  @Input({ required: true }) fieldModel!: DynamicFieldModel;
}
